import Tablist from '@accede-web/tablist';

function init(){
  var tabs = Array.prototype.slice.call( document.querySelectorAll( '[role=tablist]' ));

  tabs.forEach( tab => {
    new Tablist( tab ).mount();
  });
}

init();

